import React from "react";
import { DropdownSingle, UI_TAG_CONDENSED, colors2 } from "oolib";
import { Tag as TagComp } from "oolib/dist/v2/components/Tags";

const INTRA_FILTER_OPERATOR_OPTIONS = [
  {
    display: "Match Any (OR)",
    value: "OR",
    desc: "Returns results when at least one of the selected items match",
  },
  {
    display: "Match All  (AND)",
    value: "AND",
    desc: "Returns results only when all selected items match",
  },
  {
    display: "Exclude (NOT)",
    value: "NOT",
    desc: "Excludes results that match the selected items",
  },
];

const TAG_LABELS = { OR: "Match Any", AND: "Match All", NOT: "Exclude" };

export const IntraFilterOperatorSelect = ({ filterId, annoFilterBucketKey, intraFilterOperator = "OR", onIntraFilterOperatorChange }) => {
  const currentValue =
    INTRA_FILTER_OPERATOR_OPTIONS.find((o) => o.value === intraFilterOperator) || INTRA_FILTER_OPERATOR_OPTIONS[0];

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <DropdownSingle
        options={INTRA_FILTER_OPERATOR_OPTIONS}
        value={currentValue}
        onChange={(id, val) => onIntraFilterOperatorChange(filterId, val.value, annoFilterBucketKey)}
        S
        // lightboxStyle={{ width: "300px" }}
        popOutOfOverflowHiddenParent={true}
        genCustomSelectComp={() => (
          <TagComp
            display={TAG_LABELS[intraFilterOperator] || "Match Any"}
            size="XS"
            typo={UI_TAG_CONDENSED}
            style={{ background: colors2.grey5 }}
          />
        )}
      />
    </div>
  );
};
